export default __webpack_public_path__ + "static/spontaneous-lake-6d3c9177a866bead10c05a1da9942c56.jpg";